import script from "./WalletBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletBalance.vue?vue&type=script&setup=true&lang=js"

import "./WalletBalance.vue?vue&type=style&index=0&id=51a18dea&lang=css"

const __exports__ = script;

export default __exports__